export default (function () {
    const constantLink = {
        init() {
            $('.js--constant_link').click(function (e) {
                e.preventDefault();
                const scrollTo = $(this).data('scroll-to');
                if ($(scrollTo).length > 0) {
                    $('html, body').animate({ scrollTop: $(scrollTo).offset().top });
                }
            });
        },
    };
    $(document).ready(() => {
        constantLink.init();
    });
}());
